import * as React from 'react';

import { Form } from '@independent-software/typeui/controls/Form';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Panel } from '@independent-software/typeui/controls/Panel';
import { DataTable } from '@independent-software/typeui/controls/DataTable';
import { Checkbox } from '@independent-software/typeui/controls/Checkbox';

import { Project, ProjectFactory } from '../../resource/'; 
import { List, IListState, IListProps, SearchFilter } from '../../services/';

import { IAuth } from '../../AuthContext';
import { IconBar, Export } from '../../modules';
import { Gate } from '../../controls/Gate';

interface IListProjectsProps extends IListProps {
  /**
   * Event is fired when a project is clicked.
   */
  onClick?: (project:Project) => void;
}

interface IListProjectsState extends IListState<Project> {
}

class ListProjects extends List<Project, IListProjectsProps, IListProjectsState> {
  constructor(props: IAuth & IListProjectsProps) {
    super(props, ProjectFactory, 'name', 'asc');

    // Initialize state (list initializes its own part of the state):
    this.state = {
      ...this.state
    };
  }

  handleSearch = (value:string) => {
    this.setFilter('q', 'like', value);
  }  

  render() {
    let p = this.props;

    let filter = 
    <React.Fragment>
      <Panel.Content>
        <Form.Uncontrolled hint="Type to search records">
          <SearchFilter value={this.getFilter('q', 'like')} onSearch={this.handleSearch}/>
        </Form.Uncontrolled>
      </Panel.Content>
      <Panel.Footer>
        <div style={{display: "flex", justifyContent: 'space-between'}}>
          <Gate right='can_delete_projects'>
            <Form.Uncontrolled>
              <Checkbox label="Include deleted items" name="trash" type="toggle" checked={this.getTrash()} onChange={this.handleTrash}/>
            </Form.Uncontrolled>
          </Gate>
          <Export onExport={this.handleExport}/>
        </div>
      </Panel.Footer>      
    </React.Fragment>

    return (
      <React.Fragment>
        <IconBar>
          <Panel.Icon icon="tools" width={350}>
            {filter}
          </Panel.Icon>
        </IconBar> 
        <DataTable error={this.state.error} loading={this.state.loading} scrollTop={this.state.scrollTop} onScroll={this.handleScroll} data={this.state.items} onFetch={this.handleFetch} onClick={p.onClick} onOrder={this.handleOrder} order={this.getOrder()} dir={this.getDir()}>
          <DataTable.Column weight={4} label="Name" order="name" dir="asc">{(item:Project) => item.name}</DataTable.Column>
          <DataTable.Column align="right" weight={1} label="Campaigns" order="campaigns_count" dir="desc">{(item:Project) => item.campaigns_count}</DataTable.Column>
          <DataTable.Column weight={4} label="Agency" order="agency" dir="asc">{(item:Project) => item.agency}</DataTable.Column>
          <DataTable.Column weight={4} label="Manager" order="manager" dir="asc">{(item:Project) => item.manager}</DataTable.Column>
        </DataTable>
        <Dialog.Xhr open={this.state.exportError != null} error={this.state.exportError} onClose={this.handleCloseDialog}/>
      </React.Fragment>
    );
  }
}

export { ListProjects };
